<template>
  <div class="switcher" ref="langRef" v-if="currentLocale">
    <div class="switcher__button" @click="setSwitcherVisible(!isSwitcherVisible)">
      <img class="switcher__button-flag" :src="currentLocale.flag" :alt="currentLocale.code">
      <p>{{ currentLocale.name }}</p>
    </div>
    <div class="switcher__menu" :class="[{active: isSwitcherVisible}]">
      <div
          class="switcher__menu-button"
          v-for="locale of locales"
          :key="locale.code"
          @click="switchLocale(locale.code)"
      >
        <img
          :class="[{ active: currentLocale.code === locale.code}]"
          :src="locale.flag"
          :alt="locale.code"
        />
        <p>{{ locale.name }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {Languages} from "@/core/api/languages.js";
import translation from "@/core/helpers/translations.js";
import {computed, onMounted, ref, watch} from "vue";
import translations from "@/core/helpers/translations.js";
import {useRoute, useRouter} from "vue-router";
import {useAuthStore} from "@/stores/auth.js";
import {onClickOutside} from "@vueuse/core";

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})
const userUuid = computed(() => {
  return authStore.user.uuid ? authStore.user.uuid : ''
})

const locales = ref([])
const currentLocale = ref(null)

const isSwitcherVisible = ref(false)
const setSwitcherVisible = (state) => {
  isSwitcherVisible.value = state
}

const langRef = ref(null)
onClickOutside(langRef, () => isSwitcherVisible.value = false)

const getLanguages = async () => {
  const res = await Languages.getLanguages()
  locales.value = res.data.languages.filter((locale) => translation.supportedLocales.includes(locale.code));
  currentLocale.value = locales.value.find((locale) => locale.code === translation.currentLocale)
}

const switchLocale = async (newLocale) => {
  // if (userUuid.value && accessToken.value) {
  //   const res = await Auth.setLanguage(userUuid.value, accessToken.value, newLocale)
  //
  //   if (!res.errors) {
  //     authStore.setUser({
  //       user: res.data.updateUser.user,
  //       accessToken: accessToken.value
  //     })
  //
  //     if (newLocale !== translation.currentLocale) {
  //       translations.switchLanguage(newLocale)
  //     }
  //
  //     setSwitcherVisible(false)
  //
  //     await router.push({
  //       name: route.name,
  //       params: {
  //         ...route.params,
  //         locale: newLocale
  //       },
  //       query: { ...route.query }
  //     })
  //   }
  // } else {
  setSwitcherVisible(false)
  translations.switchLanguage(newLocale)
  await router.push({
    name: route.name,
    params: {
      ...route.params,
      locale: newLocale
    },
    query: { ...route.query }
  })
}

watch (
  () => translation.currentLocale,
  () => {
    currentLocale.value = locales.value.find((locale) => locale.code === localStorage.getItem('fpt-user-locale'))
  }
)

onMounted(async () => {
  await getLanguages()
})
</script>

<style lang="scss" scoped>
.switcher {
  position: relative;
  z-index: 2;
  width: 158px;

  &__button {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 8px;
    border: 1px solid #D596FF;
    background-color: #F5F5F5;
    padding: 5px 10px;
    transition: 0.2s;

    &-flag {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      box-sizing: content-box;
      object-fit: cover;
    }

    &:hover {
      background-color: #dedede;
    }
  }

  &__menu {
    position: absolute;
    z-index: 3;
    top: -5px;
    left: 0;
    transform: translateY(-100%);
    display: flex;
    flex-direction: column-reverse;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    border-radius: 8px;

    &.active {
      max-height: 1000px;
    }

    &-button {
      cursor: pointer;
      padding: 5px 10px;
      background-color: $white;
      box-sizing: content-box;
      border: 1px solid #D596FF;
      display: flex;
      align-items: center;
      gap: 5px;
      transition: 0.2s;

      &:first-child {
        border-radius: 0 0 8px 8px;
      }
      &:last-child {
        border-radius: 8px 8px 0 0;
      }

      &:hover {
        background-color: #dedede;
      }

      &.active {
        cursor: not-allowed;
        filter: grayscale(100%);

        &:hover {
          background-color: $white;
        }
      }

      & img {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
}
</style>